import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    requestPolicies: [],
    requestPolicy: {},
    fetchingRequestPolicies: false,
    addingRequestPolicy: false,
    updatingRequestPolicy: false,
    removingRequestPolicy: false,
    gettingRequestPolicy: false,
  },
  mutations: {
    // API
    SET_REQUESTPOLICIES(state, data) {
      state.requestPolicies = data.result
    },
    GET_REQUESTPOLICY(state, data) {
      state.requestPolicy = data
    },
    SET_FETCHING_REQUESTPOLICY(state, value) {
      state.fetchingRequestPolicies = value
    },
    SET_ADDING_REQUESTPOLICY(state, value) {
      state.addingRequestPolicy = value
    },
    SET_UPDATING_REQUESTPOLICY(state, value) {
      state.updatingRequestPolicy = value
    },
    SET_REMOVING_REQUESTPOLICY(state, value) {
      state.removingRequestPolicy = value
    },
    REMOVE_REQUESTPOLICY(state, id) {
      state.requestPolicies = state.requestPolicies.filter(u => u.id !== id)
    },
    SET_GETTING_REQUESTPOLICY(state, value) {
      state.gettingRequestPolicy = value
    },
  },
  actions: {
    fetchRequestPolicies({ commit }) {
      commit('SET_FETCHING_REQUESTPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').get(`/projects/${projectId()}/requestpolicies`)
          .then(response => {
            commit('SET_REQUESTPOLICIES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_REQUESTPOLICY', false) })
      })
    },

    addRequestPolicy({ commit }, query) {
      commit('SET_ADDING_REQUESTPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').post(`/projects/${projectId()}/requestpolicies`, query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_REQUESTPOLICY', false) })
      })
    },

    updateRequestPolicy({ commit }, query) {
      commit('SET_UPDATING_REQUESTPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').put(`/projects/${projectId()}/requestpolicies/${query.id}`, query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_REQUESTPOLICY', false) })
      })
    },

    removeRequestPolicy({ commit }, id) {
      commit('SET_REMOVING_REQUESTPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').delete(`/projects/${projectId()}/requestpolicies/${id}`)
          .then(response => {
            commit('REMOVE_REQUESTPOLICY', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_REQUESTPOLICY', false) })
      })
    },

    getRequestPolicy({ commit }, id) {
      commit('SET_GETTING_REQUESTPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').get(`/projects/${projectId()}/requestpolicies/${id}`)
          .then(response => {
            commit('GET_REQUESTPOLICY', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_REQUESTPOLICY', false) })
      })
    },
  },
}
